import { ReactElement, useMemo } from 'react';
import { useTaskDashboard } from '../providers';
import { UIText } from '@/ui';
import { concrete } from '@/ui/styles';
import { useTasksTranslation } from '../hooks';

export function LiveTasksIndicator(): ReactElement {
    const { t } = useTasksTranslation();
    const { tasks } = useTaskDashboard();

    // The count is rendered separately, above the word, so these keys hold the
    // noun alone — `count` still picks the right plural form.
    const activeTasks = useMemo(() => tasks.length, [tasks]);
    const activeTasksText = useMemo(
        () =>
            t('components.live_tasks_indicator.tasks', { count: activeTasks }),
        [activeTasks, t]
    );

    const alertedTasks = useMemo(
        () => tasks.filter((task) => task.status.includes('ALERT')).length,
        [tasks]
    );
    const alertedTasksText = useMemo(
        () =>
            t('components.live_tasks_indicator.alerts', {
                count: alertedTasks
            }),
        [alertedTasks, t]
    );

    return (
        <div style={{ display: 'flex', gap: 16 }}>
            <Item count={activeTasks} text={activeTasksText} />
            <Item count={alertedTasks} text={alertedTasksText} />
        </div>
    );
}

function Item(props: { count: number; text: string }): ReactElement {
    const { count, text } = props;

    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: 'white',
                padding: 16,
                gap: 4,
                borderRadius: 8,
                border: `1px solid ${concrete}`
            }}
        >
            <UIText variant="h1" bold>
                {count}
            </UIText>
            <UIText type="default2">{text}</UIText>
        </div>
    );
}
